import { EMBEDDED_FILTER_LABEL_CLASS } from "../../embedded-filter/constants";

const COMPACT_LABEL_CLASS =
  "mb-0.5 block text-[10px] font-semibold uppercase tracking-wide text-gray-800";

export default function FilterSelect({
  id,
  label,
  value,
  onChange,
  options = [],
  placeholder = "All",
  labelVariant = "compact",
  disabled = false,
}) {
  const labelClassName =
    labelVariant === "embedded" ? EMBEDDED_FILTER_LABEL_CLASS : COMPACT_LABEL_CLASS;
  const normalized = options.map((opt) => {
    if (typeof opt === "object" && opt != null) {
      return { value: String(opt.value), label: opt.label ?? String(opt.value) };
    }
    return { value: String(opt), label: String(opt) };
  });

  const hasAllOption = normalized.some((opt) => opt.value === "all");

  const control = (
    <div className="relative">
      <select
        id={`${id}-control`}
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 w-full appearance-none rounded border border-gray-300 bg-white px-2 pr-7 text-xs text-gray-800 transition-colors hover:border-gray-400 focus:border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-400 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-400"
      >
        {placeholder && !hasAllOption ? <option value="all">{placeholder}</option> : null}
        {normalized.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-400">
        ▾
      </span>
    </div>
  );

  if (!label) return control;

  return (
    <div className="space-y-0.5">
      <label
        htmlFor={`${id}-control`}
        className={labelClassName}
      >
        {label}
      </label>
      {control}
    </div>
  );
}
